import { createGTMEcommerceEvent } from '../../core/ecommerceMapper';
import { DEFAULT_CURRENCY, normalizeSegment } from '../../core/normalizers';
import { mapGTMUserData } from '../../core/user';
import type { GTMUserDataSource } from '../../core/user';
import type { GTMEcommerceEvent } from '../../types';

export type SubscriptionEventName =
    | 'link_subscription'
    | 'unlink_subscription'
    | 'view_subscription'
    | 'enable_subscription_permission'
    | 'disable_subscription_permission';

export type SubscriptionItem = {
    id?: string;
    name?: string;
    price?: number;
    originalPrice?: number;
    simType?: 'SIM' | 'eSIM';
};

export type SubscriptionEventInput = {
    source?: string;
    event: SubscriptionEventName;
    userData?: GTMUserDataSource | null;
    segment: string;
    isOwner: boolean;
    serviceType?: string;
    dataType?: 'data' | 'contract';
    permissionType?: string;
    item?: SubscriptionItem;
};

export const createSubscriptionGAEvent = ({
    event,
    userData,
    segment,
    isOwner,
    serviceType,
    dataType,
    permissionType,
    item,
}: SubscriptionEventInput): GTMEcommerceEvent => {
    const user = mapGTMUserData(userData);
    const itemPrice = item?.price;
    const originalPrice = item?.originalPrice ?? itemPrice;
    const itemListName = serviceType;

    return createGTMEcommerceEvent(
        event,
        {
            isOwner,
            dataType,
            permissionType,
            segment: normalizeSegment(segment),
            currency: DEFAULT_CURRENCY,
            value: 0,
            itemListName,
            items: item
                ? [
                      {
                          type: 'product',
                          id: item.id,
                          name: item.name,
                          brand: 'Telia',
                          category: itemListName,
                          listName: itemListName,
                          index: 0,
                          originalPrice,
                          price: itemPrice,
                          quantity: 1,
                          simType: item.simType,
                      },
                  ]
                : [],
        },
        {
            user_id: user.user_id,
            email: user.email,
            phone: user.phone,
        },
    );
};
